var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login',{ref:"login",attrs:{"titre":"Espace employeur","texte":_vm.description,"login-label":"Nº GUSO","login-placeholder":"Entrez votre numéro Guso","targetPage":"DashboardEmployeur","type":"Employeur"},on:{"connect":_vm.connection}})
}
var staticRenderFns = []

export { render, staticRenderFns }